import { Pipe, PipeTransform } from "@angular/core";
import { Constants } from "@shared/constants";

@Pipe({
  name: "orDefaultAvatar"
})
export class OrDefaultAvatarPipe implements PipeTransform {
  transform(avatarUrl: string | null | undefined): string {
    // Return default avatar if input is null or undefined
    if (avatarUrl === null || avatarUrl === undefined || avatarUrl === "") {
      return Constants.DEFAULT_AVATAR;
    }

    // Check if the URL is an absolute HTTP link
    if (!avatarUrl.startsWith("http://") && !avatarUrl.startsWith("https://")) {
      return Constants.DEFAULT_AVATAR;
    }

    // Check if it's an image file by extension
    const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".webp", ".svg"];
    const hasImageExtension = imageExtensions.some(ext => avatarUrl.toLowerCase().endsWith(ext));

    // If URL doesn't end with an image extension and doesn't have a query string
    // (which might indicate a dynamic image), use default avatar
    if (!hasImageExtension && !avatarUrl.includes("?")) {
      return Constants.DEFAULT_AVATAR;
    }

    return avatarUrl;
  }
}
